import Collapsable from "components/Collapsable";
import Content from "components/Content";
import Label from "components/Label";
import React, { FC, useState } from "react";
import { HiChevronDown as ChevronDown } from "react-icons/hi";

import { FAQs } from "./constants";
import styles from "./styles.module.scss";

const FAQ: FC = () => {
  const [selectedQuestion, setSelectedQuestion] = useState<null | string>(null);

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} variant="h2" color="primary">
        FAQs
      </Label>
      <div>
        {FAQs.map(({ question, answer }) => (
          <Collapsable
            open={selectedQuestion === question}
            onSelect={(id: string) => {
              if (id === selectedQuestion) setSelectedQuestion(null);
              else setSelectedQuestion(id);
            }}
            id={question}
            className={styles.collapsable}
            header={
              <div className={styles.question}>
                <Label variant="s3" color="primary">
                  {question}
                </Label>
                <ChevronDown
                  className={`${styles.chevron} ${
                    selectedQuestion === question && styles.chevronUp
                  }`}
                />
              </div>
            }
          >
            <Label>{answer}</Label>
          </Collapsable>
        ))}
      </div>
    </Content>
  );
};

export default FAQ;
